let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fnpAC")).then(() => parcelRequire('6HuPb'));